import React from 'react';
import { Route, Switch } from 'react-router-dom';
import UserIndex from './pages/intranet_admin/Users';
import Groups from './pages/intranet_admin/Groups';
import Profile from './pages/intranet_admin/Profile/EditProfile';
import Login from './pages/intranet_admin/Auth/Login';
import RecoveryPassword from './pages/intranet_admin/Auth/RecoveryPassword';
import PrivateMiddlewareAdmin from './routes/middleware/PrivateMiddlewareAdmin';
import PublicMiddleware from './routes/middleware/PublicMiddleware';
import MainThemeAdmin from './template/MainTheme/layouts/intranet_admin';
import Preferences from './pages/intranet_admin/Preferences';
import EventRepresentations from './pages/intranet_admin/EventRepresentations';
import EventObjectives from './pages/intranet_admin/EventObjectives';

const AdminRoutes = () => (
    <Switch>
        <Route path="/admin/login">
            <PublicMiddleware>
                <MainThemeAdmin showLayouts={false}>
                    <Login />
                </MainThemeAdmin>
            </PublicMiddleware>
        </Route>
        <Route path="/admin/recovery-password">
            <PublicMiddleware>
                <MainThemeAdmin showLayouts={false}>
                    <RecoveryPassword />
                </MainThemeAdmin>
            </PublicMiddleware>
        </Route>
        <PrivateMiddlewareAdmin>
            <Switch>
                <Route path="/admin/users">
                    <MainThemeAdmin showLayouts={true}>
                        <UserIndex />
                    </MainThemeAdmin>
                </Route>
                <Route path="/admin/roles">
                    <MainThemeAdmin showLayouts={true}>
                        <Groups />
                    </MainThemeAdmin>
                </Route>
                <Route path="/admin/preferences">
                    <MainThemeAdmin showLayouts={true}>
                        <Preferences />
                    </MainThemeAdmin>
                </Route>
                <Route path="/admin/edit-profile">
                    <MainThemeAdmin showLayouts={true}>
                        <Profile />
                    </MainThemeAdmin>
                </Route>
                <Route path="/admin/event-representations">
                    <MainThemeAdmin showLayouts={true}>
                        <EventRepresentations />
                    </MainThemeAdmin>
                </Route>
                <Route path="/admin/event-objectives">
                    <MainThemeAdmin showLayouts={true}>
                        <EventObjectives />
                    </MainThemeAdmin>
                </Route>
                <Route path="/admin">
                    <MainThemeAdmin showLayouts={true}>
                        <></>
                    </MainThemeAdmin>
                </Route>
            </Switch>
        </PrivateMiddlewareAdmin>
    </Switch>
);

export default AdminRoutes;
